<div class="mt-3">
  <kl-warehouse-godown-form (closeDialog)="ok()"></kl-warehouse-godown-form>
</div>
